module.exports = __webpack_public_path__ + "static/img/form_bg.7b70c1bf.png";